export default function removeDisabledContent(contents) {
  const publishedContent = contents?.filter(
    (content) => content?.status === "published"
  );
  return publishedContent;
}
